// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[600]
        },
        outlined: {
          lineHeight: 1.4375,
          overflow: 'visible',
          // Do not override `top`; MUI aligns outlined labels via `transform` from top: 0.
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: 1.5
          },
          '&.MuiInputLabel-shrink': {
            background: theme.vars.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6,
            lineHeight: 1.2
          }
        }
      }
    }
  };
}
